<pl-container *ngIf="error">
  <div class="flex flex-col gap-6 px-4 py-4 text-center md:px-0">
    <img *ngIf="error.showPlLogo" src="assets/pl_logo_and_text_black.svg" alt="logo potentialife" class="h-[72px]" />
    <h1 class="text-pl-black">{{ error.title || ('errors.unexpected_error_title' | translate) }}</h1>
    <p class="text-center text-lg font-bold text-pl-black">
      {{ error.body || ('errors.unexpected_error_body' | translate) }}
    </p>

    <div *ngIf="!error.hideButtons" class="flex w-full justify-center gap-8">
      <pl-button [variant]="ButtonVariant.white" [padding]="ButtonPadding.big" (click)="refreshPage()">
        {{ 'utils.refresh_page' | translate }}
      </pl-button>
      <pl-button [variant]="ButtonVariant.white" [padding]="ButtonPadding.big" (click)="openZendesk()">
        {{ 'home.contact_us' | translate }}
      </pl-button>
    </div>
  </div>
</pl-container>
